export const AWS_REGION_OPTIONS = [
  // Backend enum values must match these strings exactly:
  // - "North America (NA)"
  // - "North America 2 (NA2)"
  // - "Canada (CA)"
  // - "Europe (EU)"
  { code: 'NA', value: 'North America (NA)', label: 'North America (NA)' },
  { code: 'NA2', value: 'North America 2 (NA2)', label: 'North America 2 (NA2)' },
  { code: 'CA', value: 'Canada (CA)', label: 'Canada (CA)' },
  { code: 'EU', value: 'Europe (EU)', label: 'Europe (EU)' },
] as const;

export type AwsRegionValue = (typeof AWS_REGION_OPTIONS)[number]['value'];

export const ENVIRONMENT_TYPE_OPTIONS = ['dev', 'uat', 'nonprod', 'prod', 'product-qa'] as const;
export type EnvironmentTypeValue = (typeof ENVIRONMENT_TYPE_OPTIONS)[number];

export function normalizeAwsRegion(input: string | null | undefined): AwsRegionValue {
  const fallback = AWS_REGION_OPTIONS[0].value;
  if (!input) return fallback;

  // already a valid value?
  const byValue = AWS_REGION_OPTIONS.find((o) => o.value === input);
  if (byValue) return byValue.value;

  // sometimes backend may return just the short code (NA/NA2/CA/EU)
  const byCode = AWS_REGION_OPTIONS.find((o) => o.code === input);
  return byCode?.value ?? fallback;
}

